import { Formik, Form } from "formik";
import React from "react";
import PropTypes from "prop-types";
const FormContainer = ({
  children,
  initialValues = {},
  validation,
  handleSubmit = () => {},
  handleChange = () => {},
  handleValidationError = () => {},
}) => (
  <Formik
    initialValues={{
      ...initialValues,
      ...(initialValues.password ? { password: "" } : {}),
    }}
    validationSchema={validation}
    onValidationError={(errorValues) => {
      // console.log({ errorValues })
      handleValidationError(errorValues);
    }}
    // handleChange={handleChange}
    onSubmit={(values, props) => {
      // console.log({ values })
      const { setSubmitting } = props;
      setTimeout(async () => {
        await handleSubmit(values, props);
        setSubmitting(false);
      }, 50);
    }}
  >
    {({
      //  values,
      errors,
      //  touched,
      // handleChange,
      //  handleBlur,
      handleSubmit,
      //  isSubmitting
      /* and other goodies */
    }) => (
      <Form
        onChange={(...args) => {
          handleChange(...args);
        }}
        onSubmit={(...args) => {
          handleSubmit(...args);
        }}
      >
        {children}
      </Form>
    )}
  </Formik>
);

FormContainer.propTypes = {
  children: PropTypes.node,
  initialValues: PropTypes.object,
  validation: PropTypes.object,
  handleSubmit: PropTypes.func,
};
export default FormContainer;
